import { render } from "./FormRelManyCategories.vue?vue&type=template&id=df51c620"
import script from "./FormRelManyCategories.vue?vue&type=script&lang=js"
export * from "./FormRelManyCategories.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelManyCategories.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df51c620"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df51c620', __exports__)) {
    console.log('reload')
    api.reload('df51c620', __exports__)
  }
  
  module.hot.accept("./FormRelManyCategories.vue?vue&type=template&id=df51c620", () => {
    console.log('re-render')
    api.rerender('df51c620', render)
  })

}


export default __exports__